import { Fragment } from 'react/jsx-runtime'
import type { step } from '../../../../utils/recipeUtils'
import RecipeStep from './RecipeStep'
import NewRecipeStep from './NewRecipeStep'

interface RecipeStepListProps {
  steps: step[]
  setSteps: React.Dispatch<React.SetStateAction<step[]>>
}

function RecipeStepList({ steps, setSteps }: RecipeStepListProps) {
  const newStep = () => {
    const newSteps = [...steps]
    const newStepNumber =
      newSteps
        .filter(step => !step.deleted)
        .reduce((max, step) => {
          return step.step_number > max ? step.step_number : max
        }, 0) + 1

    const newStep: step = {
      id: 0,
      step_number: newStepNumber,
      step: '',
      new: true,
    }
    newSteps.push(newStep)
    setSteps(newSteps)
  }

  const setStep = (index: number, newStep: step) => {
    const newSteps = [...steps]
    newSteps[index] = newStep
    setSteps(newSteps)
  }
  const generateSteps = () => {
    return steps.reduce((current, step, index) => {
      if (step.deleted) return current
      current.push(
        <RecipeStep
          key={step.step_number}
          index={index}
          step={step}
          setStep={setStep}
        />
      )
      return current
    }, [] as React.ReactNode[])
  }

  return (
    <div className="recipe-list-container">
      {
        <Fragment>
          {generateSteps()}
          <NewRecipeStep newStep={newStep} />
        </Fragment>
      }
    </div>
  )
}

export default RecipeStepList
